// libraries
// services
import AxiosInstanceCreator from 'services/api';
import {
  IUser,
  ReqGetUserDetail,
  ReqUserList,
  ResUserDetail,
  ResUsers,
  UserDetailInfo
} from '../models/user.model';
import { BaseApiResponse, ResultBaseProps } from 'modules/common';
import { AxiosInstance } from 'axios';
import { ReqMasterLogin, ResMasterLogin } from '../models/master.model';

const userInstance = new AxiosInstanceCreator().create();

export const userApi = {
  /**
   * 관리자 목록 조회
   * @param {company, keyword, page, size} data
   * @returns
   */
  async getUsers(query: string): Promise<ResUsers> {
    return userInstance.get(`/users?${query}`).then((res) => res.data);
  },

  /**
   * 관리자 상세 조회
   * @param {userId} id
   * @returns
   */
  async getUsersId(id: string): Promise<ResUserDetail> {
    return userInstance.get(`/users/${id}`).then((res) => res.data);
  },

  /**
   * 관리자 업데이트
   * @param { userId, companyId, mobile, username, email, designationId, birthDate, nationId, bloodType, iqamaNo, mobilization, role,  passportAssign} data
   * @returns
   */
  async updateUser(formData: FormData): Promise<ResultBaseProps> {
    return userInstance
      .put('/users', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
      .then((res) => res.data);
  },

  /**
   * worker 등록
   * @param {} data
   * @returns
   */
  async createWorker(formData: FormData): Promise<ResultBaseProps> {
    return userInstance
      .post('/users/worker', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
      .then((res) => res.data);
  },

  /**
   * 관리자가 관리자 등록
   * @param { file, companyId, mobile, username, email, designationId, birthDate, nationId, bloodType, iqamaNo, mobilization, role, passportAssign } data
   * @returns
   */
  async createUser(formData: FormData): Promise<ResultBaseProps> {
    return userInstance
      .post('/users', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
      .then((res) => res.data);
  },

  /**
   * 관리자 검색 페이지
   * @param { company, passport, keyword, page, size } data
   * @returns
   */
  async getUserMetas(query: string): Promise<ResUsers> {
    return userInstance.get(`/users/search/page?${query}`).then((res) => res.data);
  },

  /**
   * 관리자 삭제
   * @param {id} id
   * @returns
   */
  async deleteUser(id: string): Promise<ResultBaseProps> {
    return userInstance.delete(`/users/${id}`).then((res) => res.data);
  },

  /**
   * 관리자 data삭제
   * @param {[userId]} data
   * @returns
   */
  async deleteUserData(userIds: string[]): Promise<ResultBaseProps> {
    return userInstance.post(`/users/delete`, userIds).then((res) => res.data);
  },

  /**
   * 관리자 사진 조회
   * @param {fileId} id
   * @returns
   */
  async getUserDownloadAPI(id: string): Promise<string> {
    const res = await userInstance.get(`/users/downloads/${id}`, {
      responseType: 'blob',
      headers: {
        'Content-Type': 'image/jpeg;charset=UTF-8, application/octet-stream; charset=UTF-8'
      }
    });

    const imageURL = URL.createObjectURL(res.data);
    return imageURL;
  },

  /**
   * 모바일, 국가 업데이트
   * @param {nationId, mobile, code} data
   * @returns
   */
  async updateUserMobile(query: string): Promise<ResultBaseProps> {
    return userInstance.put(`/users/mobile?${query}`).then((res) => res.data);
  }
};

export class UserAPIV2 {
  Axios: AxiosInstance;

  constructor() {
    this.Axios = new AxiosInstanceCreator().create();
  }

  /** 관리자 페이지 조회 API */
  async getUserList(params: ReqUserList): Promise<BaseApiResponse<unknown, IUser>> {
    return this.Axios.get<BaseApiResponse<unknown, IUser>>(`/users`, { params }).then(
      (res) => res.data
    );
  }

  /** 관리자 상세 조회 API */
  async getUsersId(data: ReqGetUserDetail): Promise<BaseApiResponse<UserDetailInfo>> {
    return this.Axios.get<BaseApiResponse<UserDetailInfo>>(`/users/${data.userId}`).then(
      (res) => res.data
    );
  }

  /** 관리자가 관리자 등록 API */
  async postRegisterUser(data: FormData): Promise<BaseApiResponse<UserDetailInfo>> {
    return this.Axios.post<BaseApiResponse<UserDetailInfo>>(`/users`, data, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then((res) => res.data);
  }

  /** 관리자 정보 업데이트 API */
  async putUpdateUser(data: FormData): Promise<BaseApiResponse<UserDetailInfo>> {
    return this.Axios.put<BaseApiResponse<UserDetailInfo>>(`/users`, data, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then((res) => res.data);
  }

  /** 관리자가 유저 삭제(삭제 상태로 변경) */
  async deleteUser(userId: string) {
    return this.Axios.delete(`/users/${userId}`).then((res) => res.data);
  }

  /** 관리자 파일 다운로드 API */
  async getUserDownloadAPI(id: string): Promise<string> {
    const res = await this.Axios.get(`/users/downloads/${id}`, {
      responseType: 'blob',
      headers: {
        'Content-Type': 'image/jpeg;charset=UTF-8, application/octet-stream; charset=UTF-8'
      }
    });

    const imageURL = URL.createObjectURL(res.data);
    return imageURL;
  }

  async masterLogin(request: ReqMasterLogin): Promise<ResMasterLogin> {
    const { pkgNo, tokenId } = request;

    return this.Axios.get(`/users/pkg`, {
      params: { tokenId: tokenId },
      headers: {
        'X-PKG-ID': pkgNo
      }
    }).then((res) => res.data);
  }
}
